'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _check = require('./check');

var _check2 = _interopRequireDefault(_check);

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkFn = function checkFn(otherJob, job) {
  // a promotional job should always be
  // a single level up
  if (parseInt(otherJob.level, 10) < parseInt(job.level, 10)) {
    var msg = 'Promotional job ' + otherJob.title + ' in ' + job.title + '\n    is invalid because it is a lesser level.\n    Promotional job ' + otherJob.title + '\'s level is ' + otherJob.level + '\n    and job ' + job.title + '\'s level is ' + job.level + '.\n    ' + otherJob.title + ' has been excluded.\n    ';
    if (_config.NODE_ENV !== 'production' && _config.DEBUG) {
      console.warn(msg);
    }
    return false;
  }
  if (otherJob.slug === job.slug) {
    var _msg = 'Transitional job ' + otherJob.title + ' is the same\n    as the specified job and has been excluded';
    if (_config.NODE_ENV !== 'production' && _config.DEBUG) {
      console.warn(_msg);
    }
    return false;
  }

  return true;
};

var checkPromotional = function checkPromotional(jobs) {
  return (0, _check2.default)(jobs, 'promotional', checkFn);
};

exports.default = checkPromotional;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/data/check/promotional.js
// module id = 1285
// module chunks = 0